export default "__VITE_ASSET__DjeBL1aO__";